import React from 'react'
import { Link } from 'react-router-dom'

function Textiles() {
  return (
    <>
<section className="ttm-row padding_zero-section clearfix">
  <div className="container">
    <div className="row">
      <div className="col-lg-12">
        <div className="ttm-bg ttm-col-bgcolor-yes ttm-bg ttm-col-bgimage-yes col-bg-img-one ttm-left-span spacing-2">
          <div className="ttm-col-wrapper-bg-layer ttm-bg-layer">
            <div className="ttm-col-wrapper-bg-layer-inner" />
          </div>
          <div className="layer-content">
            {/* section title */}
            <div className="section-title style2">
              <div className="title-header">
                <h3>INDUSTRIES &amp; PRODUCTION</h3>
                <h2 className="title">Leading Quality Suppliers <br /><b> of Textiles &amp;
                    Garments</b></h2>
              </div>
              <div className="title-desc">
                <p>NASK International is a leading sourcing and manufacturing agency in the textile industry. We provide premium textile and garment solutions, ensuring the apparel and home textile sectors.</p>
              </div>
            </div>{/* section title end */}
          </div>
        </div>{/* row end */}
      </div>
    </div>
  </div>
</section>
<section className="ttm-row padding_top_zero-section mt_210 res-991-margin_top_30 position-relative z-index-2 clearfix">
  <div className="container">
    {/* row */}
    <div className="row slick_slider" data-slick="{&quot;slidesToShow&quot;: 3, &quot;slidesToScroll&quot;: 1, &quot;arrows&quot;:false, &quot;autoplay&quot;:false, &quot;dots&quot;:false, &quot;infinite&quot;:true, &quot;responsive&quot;:[{&quot;breakpoint&quot;:992,&quot;settings&quot;:{&quot;slidesToShow&quot;: 2}},{&quot;breakpoint&quot;:840,&quot;settings&quot;:{&quot;slidesToShow&quot;: 2}},{&quot;breakpoint&quot;:650,&quot;settings&quot;:{&quot;slidesToShow&quot;: 1}}]}">
      <div className="col-md-4 col-sm-6">
        {/*featured-imagebox*/}
        <div className="featured-imagebox featured-imagebox-services style1">
          {/* featured-thumbnail */}
          <div className="featured-thumbnail">
            <img className="img-fluid" src="images/Kitchen%20Textile/multicolor-spiral-shape-rainbow-marshmallows-ground.jpg" alt="image" />
          </div>{/* featured-thumbnail end*/}
          <div className="featured-content">
            <div className="featured-title">
              <h3><Link to="/kitchen-textile">Kitchen Textiles</Link></h3>
              <div className="ttm-details-link">
                <Link to="/kitchen-textile"><i className="themifyicon ti-arrow-top-right" /></Link>
              </div>
            </div>
            <div className="featured-desc">
              <p>Kitchen Aprons, Kitchen Towels, Oven Mitts, Chef Uniform</p>
            </div>
          </div>
        </div>{/* featured-imagebox end*/}
      </div>
      <div className="col-md-4 col-sm-6">
        {/*featured-imagebox*/}
        <div className="featured-imagebox featured-imagebox-services style1">
          {/* featured-thumbnail */}
          <div className="featured-thumbnail">
            <img className="img-fluid" src="https://img.freepik.com/free-photo/astonished-buyer-with-long-pigtail-holding-takeaway-coffee-shopping-bag-hands_176532-10486.jpg?t=st=1738933867~exp=1738937467~hmac=ea2d6cb1b2c3804a7e2a1beaa8161cd3c5b283d76dcadf690d6b25f61d73b135&w=740" alt="image" />
          </div>{/* featured-thumbnail end*/}
          <div className="featured-content">
            <div className="featured-title">
              <h3><Link to="/cotton-tote-bags">Cotton Tote Bags</Link></h3>
              <div className="ttm-details-link">
                <Link to="/cotton-tote-bags"><i className="themifyicon ti-arrow-top-right" /></Link>
              </div>
            </div>
            <div className="featured-desc">
              <p>Cotton Bags, Tote Bags, Grocery Bags, Shopping Bags, Promotional Bags</p>
            </div>
          </div>
        </div>{/* featured-imagebox end*/}
      </div>
      <div className="col-md-4 col-sm-6">
        {/*featured-imagebox*/}
        <div className="featured-imagebox featured-imagebox-services style1">
          {/* featured-thumbnail */}
          <div className="featured-thumbnail">
            <img className="img-fluid" src="https://img.freepik.com/free-photo/front-view-worker-holding-iron_23-2149916276.jpg?t=st=1739006586~exp=1739010186~hmac=ad1f704fefd314ff691d435388e7ef4c822e678006d4a2f368ca3355c9edf8c3&w=740" alt="image" />
          </div>{/* featured-thumbnail end*/}
          <div className="featured-content">
            <div className="featured-title">
              <h3><Link to="/work-gloves">Work &amp; Safety Wear</Link></h3>
              <div className="ttm-details-link">
                <Link to="/work-gloves"><i className="themifyicon ti-arrow-top-right" /></Link>
              </div>
            </div>
            <div className="featured-desc">
              <p>Hot Mill Gloves, Factory Wear, Safety Gloves, Cotton Gloves, Leather Gloves
              </p>
            </div>
          </div>
        </div>{/* featured-imagebox end*/}
      </div>
    </div>
    {/* <div class="row">
                  <div class="col-lg-12 text-center">
                      <a class="ttm-btn ttm-btn-size-md ttm-btn-shape-square ttm-btn-style-border ttm-btn-color-dark margin_top30" href="services-2">View More Services!</a>
                  </div>
              </div> */}
    {/* row end */}
  </div>
</section>

    </>

  )
}

export default Textiles